module.exports = __webpack_public_path__ + "static/media/DSC_2428-HDR.705d5415.jpg";